var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 14.1666C23 14.6635 22.8582 15.1242 22.631 15.5295L15.3689 7.52202L22.5522 1.32834C22.8317 1.76536 23 2.27872 23 2.83346V14.1666ZM11.5 8.97593L21.4954 0.356997C21.0852 0.135707 20.6233 0 20.1251 0H2.87498C2.37612 0 1.9141 0.135707 1.50558 0.356997L11.5 8.97593ZM14.2866 8.4545L11.973 10.4508C11.8377 10.567 11.6692 10.625 11.5 10.625C11.3308 10.625 11.1623 10.567 11.027 10.4508L8.71278 8.45441L1.35887 16.5642C1.79967 16.8367 2.31625 17 2.87493 17H20.1251C20.6837 17 21.2005 16.8367 21.6411 16.5642L14.2866 8.4545ZM0.447855 1.3283C0.168467 1.76532 0 2.27867 0 2.83346V14.1666C0 14.6635 0.141163 15.1242 0.369215 15.5295L7.6304 7.52067L0.447855 1.3283Z",
    fill: "#505767"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b236088a7f48a74698877b6f2cd9ce21.svg";
export { ForwardRef as ReactComponent };